import values from "lodash/values"
import filter from "lodash/filter"
import _map from "lodash/map"

import uniq from "lodash/uniq"

export default function stepFieldsValidator(data) {
  let errors = {}

  if (!data.name) {
    errors.name = "can't be blank"
  }

  if (!data.slug) {
    errors.slug = "can't be blank"
  } else if (!data.slug.match(/^[A-Za-z](\w|-)+/)) {
    // Using same regex from HtmlValidationHelper.slug_validation
    errors.slug =
      "can only contain letters, numbers, underscores and dashes, and must begin with a letter"
  }

  if (data.helper_text?.length > 200) {
    errors.helper_text = "can't be longer than 200 characters"
  }

  if (data.trigger_field_type === 6 || data.action_field_type === 14) {
    if (values(data.populator_values).length < 2) {
      errors.populator_values =
        "must have at least two options for a dropdown list"
    } else if (
      filter(data.populator_values, p => p.name.length == 0).length > 0
    ) {
      errors.populator_values = "must not have blank names"
    } else if (
      filter(data.populator_values, p => p.value.length == 0).length > 0
    ) {
      errors.populator_values = "must not have blank values"
    } else if (
      data.populator_values.length !=
      uniq(_map(data.populator_values, p => p.value)).length
    ) {
      errors.populator_values = "must not have duplicate values"
    } else if (
      data.populator_values.length !=
      uniq(_map(data.populator_values, p => p.name)).length
    ) {
      errors.populator_values = "must not have duplicate names"
    }
  } else if (data.trigger_field_type === 4) {
    if (!data.regex_error_message) {
      errors.regex_error_message = "can't be blank"
    }
    if (!data.regex_value) {
      errors.regex_value = "can't be blank"
    } else {
      try {
        new RegExp(data.regex_value, "i")
      } catch (err) {
        errors.regex_value = "must be a valid regular expression"
      }
    }
  }

  return errors
}
